import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { ITpaSideEffects } from '../types'
import { name, TpaSymbol } from '../symbols'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { ITpa, TpaPageConfig } from '../types'
import _ from 'lodash'
import { IPageProvider, LogicalReflectorSymbol } from 'feature-pages'
import { IStructureAPI, PageFeatureConfigSymbol, StructureAPI } from '@wix/thunderbolt-symbols'
import { PinnedExternalIdStoreSymbol, IPinnedExternalIdStore } from 'feature-tpa-commons'

export const TpaSideEffects = withDependencies(
	[LogicalReflectorSymbol, StructureAPI, named(PageFeatureConfigSymbol, name), PinnedExternalIdStoreSymbol],
	(
		pageProvider: IPageProvider,
		structureApi: IStructureAPI,
		tpaPageConfig: TpaPageConfig,
		{ hasPinnedExternalId }: IPinnedExternalIdStore
	): IModelUpdatesHandlersImplementor<ITpaSideEffects> => {
		let currentWidgetsHashes: { [compId: string]: string } = {}
		return {
			featureName: name,
			handlers: {
				rebuildTpasSrcByHash(updatedWidgetsHashes) {
					// only refresh existing tpa components, ignore newly added/removed compIds
					const existingTpaCompIds = _.intersection(
						_.keys(currentWidgetsHashes),
						_.keys(updatedWidgetsHashes)
					)
					existingTpaCompIds
						.filter((compId: string) => currentWidgetsHashes[compId] !== updatedWidgetsHashes[compId])
						.forEach(async (compId: string) => {
							const contextId = structureApi.getContextIdOfCompId(compId) || 'masterPage'
							const pageReflector = await pageProvider(contextId, tpaPageConfig.pageId)
							const { rebuildTpaSrc } = (
								await pageReflector.getAllImplementersOnPageOfAsync<ITpa>(TpaSymbol)
							)[0]
							if (!hasPinnedExternalId(compId)) {
								rebuildTpaSrc(compId)
							}
						})
					currentWidgetsHashes = { ...updatedWidgetsHashes }
				},
			},
		}
	}
)
